import { render, staticRenderFns } from "./tick.vue?vue&type=template&id=2af7b999"
import script from "./tick.vue?vue&type=script&lang=js"
export * from "./tick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports